export default defineNuxtRouteMiddleware(async (to, from) => {
    // Define routes that should skip billing middleware
    const skipRoutes = [
        '/auth',
        '/settings/billing/subscribe',
        '/workspaces/create',
        '/workspaces/start-trial'
    ];

    // Skip middleware for specific routes
    if (skipRoutes.some(route => to.path.startsWith(route))) {
        return;
    }

    // Check if user is authenticated
    const authStore = useAuthStore();
    if (!authStore.token) {
        return;
    }

    const { initializeStores } = useStoreInitialization();
    await initializeStores();

    const workspaceStore = useWorkspaceStore();

    // If the user is already trialing, they can't visit the start trial page
    if ((workspaceStore.features?.billing?.trialing || workspaceStore.features?.billing?.has_subscription) && to.path.startsWith('/workspaces/start-trial')) {
        return navigateTo('/conversations')
    }

    // If the user is not trialing and does not have a subscription, redirect to the billing page
    if (!workspaceStore.features?.billing?.trialing && !workspaceStore.features?.billing?.has_subscription) {
        return navigateTo('/settings/billing/subscribe')
    }
})
